import React from 'react';
import { Link } from 'react-router-dom';
import confetti from 'canvas-confetti';

const ConfettiStarsButton = ({ to, children, className = '', ...props }) => {
  const handleClick = (e) => {
    e.preventDefault();
    
    // Configuration pour l'effet stars
    const defaults = {
      spread: 360,
      ticks: 50,
      gravity: 0,
      decay: 0.94,
      startVelocity: 30,
      colors: ["#FFE400", "#FFBD00", "#E89400", "#FFCA6C", "#FDFFB8"],
    };

    const shoot = () => {
      confetti({
        ...defaults,
        particleCount: 40,
        scalar: 1.2,
        shapes: ["star"],
      });

      confetti({
        ...defaults,
        particleCount: 10,
        scalar: 0.75,
        shapes: ["circle"],
      });
    };

    // Déclencher l'effet stars
    setTimeout(shoot, 0);
    setTimeout(shoot, 100);
    setTimeout(shoot, 200);

    // Rediriger après l'animation
    setTimeout(() => {
      window.location.href = to;
    }, 1500);
  };

  return (
    <Link
      to={to}
      className={`btn-confetti ${className}`}
      onClick={handleClick}
      {...props}
    >
      {children}
    </Link>
  );
};

export default ConfettiStarsButton;